export const getScheduleWorkShiftInitialState = {
	workShifts: null,
	error: null,
	errorShow: false,
	loading: false,
};
